<template id="">

    <aside class="md:min-h-screen flex-col items-center shadow hidden md:flex aside--desktop"
           :class="{ active: isActive }"
           v-click-outside="onClickOutside">
        <!-- Side Nav Bar-->
        <ul class="hidden md:flex h-16 flex-grow-0 flex-shrink-0 items-center justify-center w-full logo-container bg-blue-dark">
            <!-- Logo Section -->
            <li>
                <router-link :to="{ name: 'home' }" class="mx-auto" href="#">
                    <img src="../../assets/sharp-logo.png" alt="Sharp - Be Original" class="logo--white"/>
                </router-link>
            </li>
        </ul>

        <ul class="w-full md:mt-20 flex md:block justify-center items-center py-2 py:md-0">
            <li class="px-4 md:mb-6 hidden md:block 2xl:invisible">
                <a @click="isActive = !isActive"
                   class="nav-router-link nav-router-link__collapse w-16 md:w-12 h-12" >
                    <i class="fas fa-chevron-right transition-transform duration-500"></i>
                    <div class="desktop-label">
                        Collapse
                    </div>
                </a>
            </li>

            <li class="px-4 md:mb-6" v-if="profile.isSharpAdmin() ">
                <router-link
                        :to="{ name: 'adminClients' }"
                        :class="{ active: isClientRoute }"
                        active-class="active"
                        exact-active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">

                    <i class="fas fa-users"></i>
                    <div class="desktop-label inline-block">
                        Clients
                    </div>
                </router-link>
            </li>

            <li class="px-4 md:mb-6" v-if="profile.isGroupAdmin()">
                <router-link
                        :to="{ name: 'groupAdminClients' }"
                        :class="{ active: isClientRoute }"
                        active-class="active"
                        exact-active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">

                    <i class="fas fa-users"></i>
                    <div class="desktop-label inline-block">
                        Clients
                    </div>
                </router-link>
            </li>

            <li class="px-4 md:mb-6" v-if="profile.isSuperAdmin() ">
                <router-link
                        :to="{ name: 'staffManagement' }"
                        active-class="active"
                        exact-active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">

                    <i class="fas fa-user-shield"></i>
                    <div class="desktop-label inline-block">
                        Staff
                    </div>
                </router-link>
            </li>

        </ul>

        <ul class="w-full mt-auto block">
            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'profile' }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-cog"></i>
                    <div class="desktop-label inline-block">
                        Profile
                    </div>
                </router-link>
            </li>
            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'contact' }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12" >
                    <i class="fas fa-phone"></i>
                    <div class="desktop-label inline-block">
                        Contact Sharp
                    </div>
                </router-link>
            </li>
            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'signOut' }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-sign-out"></i>
                    <div class="desktop-label inline-block">
                        Sign Out
                    </div>
                </router-link>
            </li>
        </ul>
    </aside>
</template>
<script charset="utf-8">
    import vClickOutside from 'click-outside-vue3'
    import Vuex from 'vuex';

    export default {
        name: 'AdminDesktopNav',
        data() {
            return {
                isActive: false
            }
        },
        directives: {
            clickOutside: vClickOutside.directive
        },
        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),

            isClientRoute() {
                return this.$route.name == 'adminClientsAdd' ||
                    this.$route.name == 'adminClients';
            },
        },
        methods: {
            onClickOutside () {
                this.active = false;
            }
        }
    }
</script>

